import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode, Ref } from 'react'
import styles from './chip.module.css'
import { cx } from './cx'

interface ChipExtra {
  count?: number
  children: ReactNode
}

/** Чип-переключатель (фильтр): выбранный — чёрный. Состояние передаётся через `pressed`. */
export function Chip({
  pressed = false,
  onCard = false,
  count,
  className,
  children,
  type = 'button',
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & ChipExtra & { pressed?: boolean; onCard?: boolean }) {
  return (
    <button
      type={type}
      aria-pressed={pressed}
      className={cx(styles.chip, onCard && styles.onCard, className)}
      {...rest}
    >
      {children}
      {count !== undefined && <span className={styles.count}>{count}</span>}
    </button>
  )
}

/** Чип-ссылка для вкладок навигации; активный получает `data-status="active"` от роутера. */
export function ChipLink({
  count,
  className,
  children,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement> & ChipExtra & { ref?: Ref<HTMLAnchorElement> }) {
  return (
    <a className={cx(styles.chip, className)} {...rest}>
      {children}
      {count !== undefined && <span className={styles.count}>{count}</span>}
    </a>
  )
}
